<div class="banner-notification spacing--padding-bottom spacing--padding-top spacing--padding-left">
  <agr-extended-notification
    notificationType="info"
    [title]="'app.banner-notification.title' | translate"
    [actionText]="getActionText()"
    (action)="toggleNotification()"
  >
    <div class="paragraph-margin" *ngIf="showNotification">
      <p class="text--small">{{ 'app.banner-notification.description' | translate }}</p>
      <div *ngFor="let item of texts">
        <b>{{ item.title | translate }}</b>
        <p>{{ item.description | translate }}</p>
      </div>
      <p class="text--small">{{ 'app.banner-notification.extra-information' | translate }}</p>
    </div>
  </agr-extended-notification>
</div>
